import { gql, useQuery } from '@apollo/client'
import { EmptyState, InlineDropdown, Search, Spinner } from '@blend-ed/blendx-ui'
import { useCurrency } from '@blend-ed/blendx-platform/hooks'
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n'
import { useEffect, useMemo, useState } from 'react'
import { BlendxCard } from '@blend-ed/blendx-ui'
import useFetchCart from '../../hooks/useFetchCart'
import messages from './messages'

const GET_COURSE_OVERVIEWS = gql`
  query CourseOverviews {
    courseOverviewsCourseoverview {
      id
      displayName
      shortDescription
      courseImageUrl
    }
  }
`;

function WishList({ intl }) {
    const [searchValue, setSearchValue] = useState('')
    const [filterValue, setFilterValue] = useState('')
    const { wishlistCartData, loading } = useFetchCart()
    const [renderData, setRenderData] = useState([])

    const { symbol } = useCurrency();

    const { data: courseOverviews } = useQuery(GET_COURSE_OVERVIEWS,
        { context: { headers: { 'x-hasura-role': 'learner' } } }
    )

    const parsedCartData = useMemo(() => {
        return wishlistCartData?.map(item => {
            if (item.course) {
                return {
                    image: courseOverviews?.courseOverviewsCourseoverview.find(overview => overview.id === item.course.openedxCourseId)?.courseImageUrl,
                    title: courseOverviews?.courseOverviewsCourseoverview.find(overview => overview.id === item.course.openedxCourseId)?.displayName,
                    description: courseOverviews?.courseOverviewsCourseoverview.find(overview => overview.id === item.course.openedxCourseId)?.shortDescription,
                    price: item.course.price,
                    type: 'price',
                    variant: 'course',
                    link: '/course/' + item.course.openedxCourseId,
                    courseId: item.course.openedxCourseId,
                    id: item.id
                }
            } else if (item.program) {
                return {
                    image: item.program.image,
                    title: item.program.name,
                    description: item.program.description,
                    price: item.program.price,
                    type: 'price',
                    variant: 'program',
                    link: '/program/' + item.program.id,
                    programId: item.program.id,
                    id: item.id
                }
            }
        })

    }, [wishlistCartData, courseOverviews])

    useEffect(() => {
        setRenderData(parsedCartData)
    }, [parsedCartData])

    // search filter function
    useEffect(() => {
        // course search filter
        const filteredData = parsedCartData.filter((item) => {
            return item?.title?.toLowerCase().includes(searchValue.toLowerCase())
        })
        setRenderData(filteredData)
    }, [searchValue])

    // filter filter function
    useEffect(() => {
        // filter courses and programs by A-Z
        if (filterValue === 'atoz') {
            setRenderData([...renderData].sort((a, b) => a.title.localeCompare(b.title, undefined, { numeric: true, sensitivity: 'base' })))
        }
        //filter courses and programs by Z-A
        if (filterValue === 'ztoa') {
            setRenderData([...renderData].sort((a, b) => b.title.localeCompare(a.title, undefined, { numeric: true, sensitivity: 'base' })))
        }
    }, [filterValue])


    if (loading) {
        return (
            <div className="blendx-spinner-container">
                <Spinner animation="border" size="lg" variant="dark" />
            </div>
        )
    }

    return (
        <main>
            <div className='course-body'>
                <div className="course-body-header">
                    <Search placeholder={intl.formatMessage(messages.search)} onChange={(e) => { setSearchValue(e) }} />
                    <InlineDropdown border onSelect={(e) => { setFilterValue(e.value) }}>
                        <InlineDropdown.Item icon="edit" iconType="fill" label={intl.formatMessage(messages.relevent)} value="relevent" />
                        <InlineDropdown.Item icon="sort-alphabet-asc" iconType="" label={intl.formatMessage(messages.atoz)} value="atoz" />
                        <InlineDropdown.Item icon="sort-alphabet-desc" iconType="" label={intl.formatMessage(messages.ztoa)} value="ztoa" />
                        <InlineDropdown.Item icon="arrow-up-circle" iconType="fill" label={intl.formatMessage(messages.upcoming)} value="upcoming" />
                    </InlineDropdown>
                </div>
                {renderData.length > 0 ? <div className="wishlist-content">
                    {renderData.map((item, index) => (
                        <BlendxCard key={index} {...item} currency={symbol} />
                    ))}
                </div> :
                    <div className="wishlist-empty">
                        <EmptyState type="box" className="mx-auto" message={intl.formatMessage(messages.wishlistEmpty)} />
                    </div>
                }
            </div>
        </main>
    )
}

WishList.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(WishList);